export default __webpack_public_path__ + "static/media/accommodation4.02c1ee84.webp";